export const domain = `https://${window.location.host}/images`;
// export const domain = `https://www.gaopaizm.com/images`
// export const domain = `http://${window.location.host}/imagesRaw`;
